if (document.querySelector('#tudor-blog-slider')) {
if (document.querySelectorAll('#tudor-blog-slider .tudor-blog-item-custom')) {
    var flkty = new Flickity('#tudor-blog-slider .tudor-blog-lists', {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: false,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 4,
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 2,
                  }
              }
          ]
    });
}
}

if (document.querySelector('#about-tudor-slider')) {
if (document.querySelectorAll('#about-tudor-slider .tudor-blog-item-custom')) {
    var flkty = new Flickity('#about-tudor-slider .tudor-blog-lists', {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: false,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 4,
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 2,
                  }
              }
          ]
    });
}
}